module.exports = __webpack_public_path__ + "static/media/16.30f894c2.jpg";